module.exports = __webpack_public_path__ + "static/media/PDF Icon.4f2aee1b.svg";